import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8ac208"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "pt-5" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "flex space-x-2"
}
const _hoisted_5 = {
  key: 1,
  class: "space-x-2"
}
const _hoisted_6 = { class: "w-[15rem] h-[10rem] flex flex-col space-y-1 mt-8 items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { className: " border-[1px] mb-5" }, null, -1))
const _hoisted_8 = { class: "flex justify-evenly w-48 font-[800]" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { className: "mt-5 border-[1px] " }, null, -1))

import { removeItems } from "@/utils/permissions"
import {
	H1,
	H2,
	ChangePasswordButton,
	LogoutButton,
	Input,
	EditButton,
} from "../atoms"
import { useRouter } from "vue-router"
import { hasPermission } from "@/utils/permissions"
import { Permission, TypeOfUser, Profile, Notification } from "@/utils/enum"
import { useStore } from "@/store"
import { watchEffect, ref } from "vue"
import { RESET_STATES } from "@/store/mutationsTypes"
import { updateUsers } from "@/repositories/users"
import { IUpdateUser } from "@/utils/interfaces"


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  emits: [
	"changeProfile",
	"enableLoading",
	"emitError",
	"successfullyUpdated",
],
  setup(__props, { emit }) {

const store = useStore()

const router = useRouter()

const name = ref("")

let showInput = ref(false)
let welcomeMessage = ref("Bem vindo ao Portal Comissão")
let profile = ref(Profile.COMMISSION)

const logout = () => {
	router.push({ path: "/" })
	removeItems()
	store.commit(RESET_STATES)
}

const changeProfile = (value: Profile) => {
	if (profile.value != value) {
		profile.value = value
		emit("changeProfile", value)
	}

	if (value == Profile.COMMISSION) {
		welcomeMessage.value = "Bem vindo ao Portal Comissão"
	} else if (value == Profile.FAQ) {
		welcomeMessage.value = "FAQ Portal Comissão"
	}
}

const editResaleName = async () => {
	emit("enableLoading", true)

	const user = store.getters.getUserRev

	const data: IUpdateUser = {
		name: name.value,
	}

	const res = await updateUsers(user.id, data)

	if (res.status == 204) {
		emit(
			"successfullyUpdated",
			true,
			Notification.TITLE_USER_EDIT,
			Notification.SUBTITLE_USER_EDIT
		)
	} else if (res == 400) {
		emit(
			"emitError",
			true,
			Notification.TITLE_UPDATE_ERROR,
			Notification.SUBTITLE_UPDATE_ERROR
		)
	} else {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	emit("enableLoading", false)

	showInput.value = false
}

watchEffect(() => {
	name.value = store.getters.getResaleName
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(hasPermission)([_unref(Permission).ADMIN]))
          ? (_openBlock(), _createBlock(_unref(H2), {
              key: 0,
              class: "text-left text-v_dark_gray"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Olá, AIDC TECNOLOGIA LTDA. ")
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_unref(showInput))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(H2), { class: "text-left text-v_dark_gray" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Olá, " + _toDisplayString(name.value), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showInput) //@ts-ignore
 ? showInput.value = true : showInput = true)),
                      class: "active:scale-90"
                    }, [
                      _createVNode(_component_v_icon, { icon: "mdi-pencil-box-outline" })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_unref(Input), {
                      placeholder: "Atualize o nome da sua revenda",
                      modelValue: name.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                      h: "2rem",
                      class: "!font-[0.5rem]"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(EditButton), {
                      onClick: editResaleName,
                      class: "active:scale-90"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Editar")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("button", {
                      class: "active:scale-90",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(showInput) //@ts-ignore
 ? showInput.value = false : showInput = false))
                    }, [
                      _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
                    ])
                  ]))
            ])),
        _createVNode(_unref(H1), { class: "text-v_dark_blue lg:text-[2rem]" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(welcomeMessage)), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(ChangePasswordButton), {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showModalChangePassword', true))),
          class: "active:scale-90"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Trocar senha ")
          ]),
          _: 1
        }),
        _createVNode(_unref(LogoutButton), {
          onClick: logout,
          class: "active:scale-90"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sair")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeProfile(_unref(Profile).COMMISSION))),
          class: "active:scale-90"
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(
						_unref(profile) == _unref(Profile).COMMISSION &&
						'text-v_green underline decoration-v_green underline-offset-[1.7rem] decoration-2'
					)
          }, _toDisplayString(_unref(TypeOfUser).COMMISSION), 3)
        ]),
        (_unref(hasPermission)([_unref(Permission).ADMIN]))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "text-v_dark_gray2 active:scale-90",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (changeProfile(_unref(Profile).USER)))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(
						_unref(profile) == _unref(Profile).USER &&
						'text-v_green underline decoration-v_green underline-offset-[1.7rem] decoration-2'
					)
              }, _toDisplayString(_unref(TypeOfUser).USER), 3)
            ]))
          : _createCommentVNode("", true),
        (_unref(hasPermission)([_unref(Permission).RESALE]))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "text-v_dark_gray2 active:scale-90",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (changeProfile(_unref(Profile).FAQ)))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(
						_unref(profile) == _unref(Profile).FAQ &&
						'text-v_green underline decoration-v_green underline-offset-[1.7rem] decoration-2'
					)
              }, " Dúvidas ", 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_9
    ])
  ], 64))
}
}

})